// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".guide-list{z-index:1}.guide-list:after{background-color:#ede1d3;content:\"\";height:100%;left:50%;margin-left:-570px;position:absolute;top:0;width:1140px;z-index:-1}@media (max-width:576px){.guide-list:after{display:none}}@media (max-width:1200px){.guide-list:after{left:0;margin:0;width:100%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
